export default "__VITE_ASSET__LGJaEjfM__"